import { Routes } from '@angular/router';
import { dobGuard } from './core/guards/dob.guard';
import { authGuard } from './core/guards/auth.guard'; // Corrected path assumption

export const routes: Routes = [
  // Root redirect to facts
  {
    path: '',
    redirectTo: 'facts',
    pathMatch: 'full',
  },

  // Facts routes
  {
    path: 'facts',
    loadComponent: () =>
      import('./features/facts/fact-main.component').then(
        m => m.FactMainComponent,
      ),
    canActivate: [dobGuard],
  },

  // Fact detail route with dynamic id parameter
  {
    path: 'fact/:id',
    loadComponent: () =>
      import('./features/facts/fact-detail.component').then(
        m => m.FactDetailComponent,
      ),
    canActivate: [dobGuard],
  },

  // Search route (placeholder page)
  {
    path: 'search',
    loadComponent: () =>
      import('./features/search/search.component').then(m => m.SearchComponent),
    canActivate: [dobGuard],
  },

  // Stats route (placeholder page)
  {
    path: 'stats',
    loadComponent: () =>
      import('./features/stats/stats.component').then(m => m.StatsComponent),
    canActivate: [dobGuard],
  },

  // Media route (placeholder page)
  {
    path: 'media',
    loadComponent: () =>
      import('./features/media/media.component').then(m => m.MediaComponent),
    canActivate: [dobGuard],
  },

  // Profile route (auth protected)
  {
    path: 'profile',
    loadComponent: () =>
      import('./features/user/profile.component').then(m => m.ProfileComponent),
    canActivate: [authGuard, dobGuard], // Protect profile page
  },

  // About page route
  {
    path: 'about',
    loadComponent: () =>
      import('./about.component').then(m => m.AboutComponent),
    canActivate: [dobGuard],
  },

  // Privacy policy route
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./privacy-policy.component').then(m => m.PrivacyPolicyComponent),
  },

  // Terms of service route
  {
    path: 'terms-of-service',
    loadComponent: () =>
      import('./terms-of-service.component').then(
        m => m.TermsOfServiceComponent,
      ),
  },

  // New Birthday setup route (no guard)
  {
    path: 'newuser',
    loadComponent: () =>
      import('./features/user/birthday-setup.component').then(
        m => m.BirthdaySetupComponent,
      ),
  },
  // Wildcard route for any undefined routes - redirects to home
  {
    path: '**',
    redirectTo: '',
  },
];
